import React from 'react';

import QR from 'qrcode.react';
import { connect } from 'react-redux';
import bdReq from '../../@packages/@bd-uikit-web/js-helpers/bdReq';
import bdAuth from '../../@packages/@bd-uikit-web/js-helpers/bdAuth';

import { fetchDevice } from '../store/actions/deviceActions';
import { fetchUser } from '../store/actions/userActions';
import { mobileDeviceId } from '../store/actions/appActions';
import { fetchFeaturedPlaylist, fetchHomePlaylist, fetchActivePlaylist, fetchMyPlaylist, fetchFollowedCollection } from '../store/actions/playlistActions';
import { fetchSubscription } from '../store/actions/subscriptionActions';
import { FETCH_DEVICE_SUCCESS } from '../store/constants/deviceConstants';
import { BACK, ENTER, RIGHT, LEFT, EXIT } from '../util/remoteButtons';

import { setLogoFlag, setMuteFlag, fireAnalytics } from './utils';


export class Pair extends React.Component {
  constructor(props) {
    super(props);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.selectedBtn = 'None';
    this.selectedBtn1 === 'No';

    this.state = {
      open: false,
    };

    this.qrObj;
  }

  async componentDidMount() {
    fireAnalytics("Page", "Pair Page Loaded");
    let pairInterval = null;
    setTimeout(() => {
      const { back } = this.refs;
      back.focus();
      this.selectedBtn = 'Back';
    }, 300);
    const pair = async () => {
      try {
        const deviceResult = await this.props.fetchDevice(this.props.app.webosDeviceId);
        if (deviceResult.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        if (deviceResult.type === FETCH_DEVICE_SUCCESS) {
          setLogoFlag(false);
          setMuteFlag(deviceResult.payload.mute);
          clearInterval(pairInterval);
          const emailId = deviceResult.payload._embedded.user.email;
          const userId = deviceResult.payload._embedded.user.id;
          fireAnalytics('Pair', 'App Paired from Pair Page', emailId);
          await this.props.mobileDeviceId(userId);
          // TODO: Move this into a redux action. Functionality is duplicated on the splash page.
          const response = await bdReq.post('/emailLogin', { emailId });
          if (response.success) {
            bdAuth._storeToken(response.body);
          }

          const fetchUser = await this.props.fetchUser();
          if (fetchUser.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchSubscription = await this.props.fetchSubscription();
          if (fetchSubscription.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchFeaturedPlaylist = await this.props.fetchFeaturedPlaylist();
          if (fetchFeaturedPlaylist.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchMyPlaylist = await this.props.fetchMyPlaylist();
          if (fetchMyPlaylist.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchFollowedCollection = await this.props.fetchFollowedCollection();
          if (fetchFollowedCollection.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchHomePlaylist = await this.props.fetchHomePlaylist();
          if (fetchHomePlaylist.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchActivePlaylist = await this.props.fetchActivePlaylist('Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx');
          if (fetchActivePlaylist.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          clearInterval(this.onlineStatusInterval);
          this.props.history.push('/playlist/Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx');
        }
      } catch (e) {
        console.log(e);
      }
    };

    pairInterval = setInterval(() => pair(), 3000);

    return () => {
      clearInterval(pairInterval);
    };
  }

  handleKeyDown(e) {
    e.stopPropagation();
    e.preventDefault();
    switch (e.which) {
      case RIGHT:
        if (this.state.open) {
          document.getElementById('No').style.background = '';
          document.getElementById('yes').style.background = '#910048';
          // this.refs.yes.focus();
          this.selectedBtn = 'Yes';
        }
        break;
      case LEFT:
        if (this.state.open) {
          document.getElementById('yes').style.background = '';
          document.getElementById('No').style.background = '#910048';
          // this.refs.no.focus();
          this.selectedBtn = 'No';
        }
        break;
      case ENTER:
        if (this.state.open) {
          if (this.selectedBtn === 'No') {
            this.setState({ open: false });
            this.refs.back.focus();
            this.selectedBtn = 'Back';
            return;
          }
          if (this.selectedBtn === 'Yes') {
            window.open("", "_self").close();
          }
        }
        if (this.selectedBtn === 'Back') {
          this.props.history.goBack();
        }
        break;
      case 27: // ///////////////For Esc Keyboard Key
      case BACK:
        if (this.state.open) {
          this.setState({ open: false });
          this.refs.back.focus();
          this.selectedBtn = 'Back';
          return;
        }
        else this.props.history.goBack();
        break;
      case EXIT:
        if (this.state.open) {
          this.setState({ open: false });
          this.refs.back.focus();
          this.selectedBtn = 'Back';
          return;
        }
        else this.setState({ open: !this.state.open });
    }
  }

  render() {
    return (
      <div className="UpgradeWrapper" onKeyDown={this.handleKeyDown}>
        {
          this.state.open ? (
            <div id="models" className="reg-response-modal" style={{ position: 'absolute', zIndex: '9999', padding: '0%' }}>
              <div className="model" style={{ width: '40%', backgroundColor: 'black', color: 'white', borderRadius: '15px' }}>
                <img className="logo2" src="/assets/img/blackdove-logo-2020.png" alt="" style={{ width: '50%', paddingTop: '6%' }} />
                <h2 style={{ marginBottom: '2%' }}>Do you want to exit?</h2>
                <button
                  ref="no"
                  id="No"
                  onClick={() => {
                    this.setState({ open: false });
                  }}
                  style={{ background: '#910048' }}
                  className="exitPopup"
                >No
                </button>
                <button
                  ref="yes"
                  id="yes"
                  style={{ marginLeft: '2%' }}
                  className="exitPopup"
                >Yes
                </button>
              </div>
            </div>
          ) : null
        }
        <div className="qrCodeWrapper">
          <div className="content-wrapper">
            <div className="text-wrapper">
              PAIR WITH SMARTPHONE
            </div>
            <div className="scan-text-wrapper">
              Scan the below QR code using the smartphone app to pair your display
            </div>
          </div>
          <div className="qr-wrapper">
            <QR className="QRCode" value={this.props.app.webosDeviceId} size={300} renderAs="svg" />
          </div>
        </div>
        <div className="downloadButtonWrapper">
          <img className="downloadImg-wrapper" src="/assets/img/TV.png" alt="" />
          <img className="iphone-wrapper" src="/assets/img/iPhone.png" alt="" />
          <div className="info-Content-Wrapper">
            <div className="art-wrapper">
              ART THAT YOU WILL LOVE AT YOUR FINGERTIPS
            </div>
            <div className="download-art-wrapper">
              Download the mobile app today to discover, collect and share the newest artworks.
              Use the app to showcase the art that speaks to you on a range of displays across your home, or business.
            </div>
          </div>
          <div className="button-Wrapper" style={{ top: '80%', padding: '3%' }}>
            <button id="back" ref="back" className="connect-wrapper-infodiv-contentdisplay-buttonWrapper-backbtn" onClick={() => this.props.history.goBack()}>Close</button>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  mobileDeviceId: (mobileId) => dispatch(mobileDeviceId(mobileId)),
  fetchDevice: (deviceId) => dispatch(fetchDevice(deviceId)),
  fetchUser: () => dispatch(fetchUser()),
  fetchSubscription: () => dispatch(fetchSubscription()),
  fetchFeaturedPlaylist: () => dispatch(fetchFeaturedPlaylist()),
  fetchMyPlaylist: () => dispatch(fetchMyPlaylist()),
  fetchFollowedCollection: () => dispatch(fetchFollowedCollection()),
  fetchHomePlaylist: () => dispatch(fetchHomePlaylist()),
  fetchActivePlaylist: (targetPlaylistId) => dispatch(fetchActivePlaylist(targetPlaylistId)),
});
export default connect((state) => {
  const { app } = state;
  return {
    app,
  };
}, mapDispatchToProps)(Pair);
